module.exports = __webpack_public_path__ + "img/mobile.3748ce42.png";